declare namespace $ {

	type $mol_view__sub_shm_hitalama_components_editor_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_components_source__definition_shm_hitalama_components_editor_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_editor['definition'] >
		,
		ReturnType< $shm_hitalama_components_source['definition'] >
	>
	type $shm_hitalama_components_source__kind_shm_hitalama_components_editor_3 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_components_source['kind'] >
	>
	type $shm_hitalama_components_source__enabled_shm_hitalama_components_editor_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_editor['editable'] >
		,
		ReturnType< $shm_hitalama_components_source['enabled'] >
	>
	type $shm_hitalama_components_source__title_shm_hitalama_components_editor_5 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_components_source['title'] >
	>
	type $shm_hitalama_components_source__definition_shm_hitalama_components_editor_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_editor['definition'] >
		,
		ReturnType< $shm_hitalama_components_source['definition'] >
	>
	type $shm_hitalama_components_source__kind_shm_hitalama_components_editor_7 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_components_source['kind'] >
	>
	type $shm_hitalama_components_source__enabled_shm_hitalama_components_editor_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_editor['editable'] >
		,
		ReturnType< $shm_hitalama_components_source['enabled'] >
	>
	type $shm_hitalama_components_source__title_shm_hitalama_components_editor_9 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_components_source['title'] >
	>
	type $shm_hitalama_components_source__definition_shm_hitalama_components_editor_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_editor['definition'] >
		,
		ReturnType< $shm_hitalama_components_source['definition'] >
	>
	type $shm_hitalama_components_source__kind_shm_hitalama_components_editor_11 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_components_source['kind'] >
	>
	type $shm_hitalama_components_source__enabled_shm_hitalama_components_editor_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_editor['editable'] >
		,
		ReturnType< $shm_hitalama_components_source['enabled'] >
	>
	type $shm_hitalama_components_source__title_shm_hitalama_components_editor_13 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_components_source['title'] >
	>
	type $shm_textarea_code__sidebar_showed_shm_hitalama_components_editor_14 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_textarea_code['sidebar_showed'] >
	>
	type $shm_textarea_code__enabled_shm_hitalama_components_editor_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_editor['editable'] >
		,
		ReturnType< $shm_textarea_code['enabled'] >
	>
	type $shm_textarea_code__title_shm_hitalama_components_editor_16 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_textarea_code['title'] >
	>
	type $shm_textarea_code__value_shm_hitalama_components_editor_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_editor['dependencies'] >
		,
		ReturnType< $shm_textarea_code['value'] >
	>
	type $shm_textarea_code__hint_shm_hitalama_components_editor_18 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_textarea_code['hint'] >
	>
	type $shm_hitalama_components_source__definition_shm_hitalama_components_editor_19 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_editor['definition'] >
		,
		ReturnType< $shm_hitalama_components_source['definition'] >
	>
	type $shm_hitalama_components_source__kind_shm_hitalama_components_editor_20 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_components_source['kind'] >
	>
	type $shm_hitalama_components_source__enabled_shm_hitalama_components_editor_21 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_editor['editable'] >
		,
		ReturnType< $shm_hitalama_components_source['enabled'] >
	>
	type $shm_hitalama_components_source__title_shm_hitalama_components_editor_22 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_components_source['title'] >
	>
	type $shm_hitalama_components_source__definition_shm_hitalama_components_editor_23 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_editor['definition'] >
		,
		ReturnType< $shm_hitalama_components_source['definition'] >
	>
	type $shm_hitalama_components_source__kind_shm_hitalama_components_editor_24 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_components_source['kind'] >
	>
	type $shm_hitalama_components_source__enabled_shm_hitalama_components_editor_25 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_editor['editable'] >
		,
		ReturnType< $shm_hitalama_components_source['enabled'] >
	>
	type $shm_hitalama_components_source__title_shm_hitalama_components_editor_26 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_components_source['title'] >
	>
	type $shm_hitalama_components_source__definition_shm_hitalama_components_editor_27 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_editor['definition'] >
		,
		ReturnType< $shm_hitalama_components_source['definition'] >
	>
	type $shm_hitalama_components_source__kind_shm_hitalama_components_editor_28 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_components_source['kind'] >
	>
	type $shm_hitalama_components_source__enabled_shm_hitalama_components_editor_29 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_editor['editable'] >
		,
		ReturnType< $shm_hitalama_components_source['enabled'] >
	>
	type $shm_hitalama_components_source__title_shm_hitalama_components_editor_30 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_components_source['title'] >
	>
	type $mol_status__status_shm_hitalama_components_editor_31 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_editor['save_status'] >
		,
		ReturnType< $mol_status['status'] >
	>
	type $mol_deck__items_shm_hitalama_components_editor_32 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_deck['items'] >
	>
	export class $shm_hitalama_components_editor extends $mol_page {
		Title_text( ): $mol_view
		content( ): readonly($mol_view)[]
		save_status( ): string
		Deck_switch( ): ReturnType< ReturnType< $shm_hitalama_components_editor['Deck'] >['Switch'] >
		Deck_content( ): ReturnType< ReturnType< $shm_hitalama_components_editor['Deck'] >['Content'] >
		editable( ): boolean
		Tree( ): $shm_hitalama_components_source
		Logic( ): $shm_hitalama_components_source
		Style( ): $shm_hitalama_components_source
		dependencies( next?: string ): string
		Dependencies( ): $shm_textarea_code
		Default( ): $shm_hitalama_components_source
		Readme( ): $shm_hitalama_components_source
		Demo( ): $shm_hitalama_components_source
		definition( ): $shm_hitalama_map_widget_entity_custom
		saving( ): boolean
		title( ): string
		minimal_width( ): number
		title_content( ): readonly(any)[]
		body( ): ReturnType< $shm_hitalama_components_editor['content'] >
		Save_status( ): $mol_status
		Deck( ): $mol_deck
	}
	
}

//# sourceMappingURL=editor.view.tree.d.ts.map